<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addAdmin">新增</el-button> -->
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="handleSolve">解除禁用</el-button>
		    <el-button type="danger" size="small" icon="el-icon-delete" @click="handleForbid">禁用账户</el-button> -->
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%"
		 :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
			<el-table-column label="满减优惠规则" width="400">
				<template v-slot="scope">
					<el-table :data="scope.row.all_full_reduction">
						<el-table-column label="满减金额1" prop="total_price_one"></el-table-column>
						<el-table-column label="满减金额2" prop="total_price_two"></el-table-column>
						<el-table-column label="减少金额" prop="reduce_money"></el-table-column>
					</el-table>
				</template>
			</el-table-column>
			<el-table-column prop="product_type_name" label="打折分类"></el-table-column>
			<el-table-column prop="start_time" label="开始时间"></el-table-column>
			<el-table-column prop="end_time" label="结束时间"></el-table-column>
			<el-table-column label="状态">
				<template v-slot="scope">
					<el-tag type="success" v-if="scope.row.status==1">开启</el-tag>
					<el-tag type="danger" v-if="scope.row.status==2">关闭</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="230">
				<template #default="scope">
					<el-button v-if="scope.row.status==2" type="success" size="mini" @click="statusChange(scope.row)">开启</el-button>
					<el-button v-if="scope.row.status==1" type="danger" size="mini" @click="statusChange(scope.row)">关闭</el-button>
					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
					<el-button type="warning" size="mini" @click="del(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</el-card>
	<el-dialog title="会员等级详情设置" v-model="dialogFormVisible">
		<template #title>
			<el-row type="flex" justify="start">
				<el-col :span="6">
					<span>满减促销设置</span>
				</el-col>
				<el-col :span="3">
					<el-button :disabled="addDisabled" size="small" type="primary" v-show="ishowAddButton" @click="AddForm">添加</el-button>
				</el-col>
			</el-row>
		</template>
		<el-form :model="form" ref="form">
			<el-form-item v-for="(item,ii) in form.items" :key="ii">
				<label style="color: red">区间{{ii+1}}</label>
				<el-form-item>
					<el-row :gutter="20">
						<el-col :span="5">
							<label>满减优惠{{ii+1}}</label>
						</el-col>
						<el-col :span="5">
							<el-form-item :prop="'items.' + ii + '.total_price_one'" :rules="rules.total_price_one">
								<el-input v-model="item.total_price_one" placeholder="总金额1" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item :prop="'items.' + ii + '.total_price_two'" :rules="rules.total_price_two">
								<el-input v-model="item.total_price_two" placeholder="总金额2" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item :prop="'items.' + ii + '.reduce_money'" :rules="rules.reduce_money">
								<el-input v-model="item.reduce_money" placeholder="满减金额" autocomplete="off"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="1">
							<el-button @click="removeDomain(ii)">删除</el-button>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>终止优惠</label>
					</el-col>
					<el-col :span="5">
						<el-form-item prop="total_price_one_special" :rules="rules.total_price_one_special">
							<el-input v-model="form.total_price_one_special" placeholder="终止金额1" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item prop="total_price_two_special" :rules="rules.total_price_two_special">
							<el-input disabled v-model="form.total_price_two_special" placeholder="终止金额2" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item prop="reduceprice_special" :rules="rules.reduceprice_special">
							<el-input v-model="form.reduceprice_special" placeholder="满减终止金额" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>开始时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.start_time" prop="start_time">
							<el-input v-model="form.start_time" type="date" placeholder="开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-row :gutter="20">
					<el-col :span="5">
						<label>结束时间</label>
					</el-col>
					<el-col :span="10">
						<el-form-item :rules="rules.end_time" prop="end_time">
							<el-input v-model="form.end_time" type="date" placeholder="结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-checkbox-group v-model="form.checkList">
					<el-checkbox v-for="(item,index) in options" :label="item.id" :key="item.id" :value="item.id">{{item.product_sale_name}}</el-checkbox>
				</el-checkbox-group>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	export default {
		name: 'FullReduction',
		data() {
			return {
				list: [],
				loading: false,
				multipleSelection: [],
				options: [],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				ishowAddButton: true,
				ishowDelButton: true,
				addDisabled: false,
				delDisabled: false,
				btnDisabled: true,
				form: {
					items: [],
					// price_special:{

					// },
					total_price_one_special: '',
					total_price_two_special: 0,
					reduceprice_special: '',
					start_time: '',
					end_time: '',
					checkList: [],
				},
				rules: {
					total_price_one: [{
						required: true,
						message: '总金额1不能为空',
						trigger: 'blur'
					}],
					total_price_two: [{
						required: true,
						message: '总金额2不能为空',
						trigger: 'blur'
					}],
					reduce_money: [{
						required: true,
						message: '总金额3不能为空',
						trigger: 'blur'
					}],
					total_price_one_special: [{
						required: true,
						message: '终止金额1不能为空',
						trigger: 'blur'
					}],
					reduceprice_special: [{
						required: true,
						message: '满减终止金额不能为空',
						trigger: 'blur'
					}],
					start_time: [{
						required: true,
						message: '开始时间不能为空',
						trigger: 'blur'
					}],
					end_time: [{
						required: true,
						message: '结束时间不能为空',
						trigger: 'blur'
					}],
					checkList: [{
						type: 'array',
						required: true,
						message: '请至少选择一个分类',
						trigger: 'click'
					}],
				}
			}
		},
		methods: {
			getFullReduction() {
				this.loading = true
				this.httpPost({
					url: '/admin/fullreduction/fll_reduction_list',
					data: {
						routePath: this.$route.path
					}
				}).then((res) => {
					this.list = res.data;
					this.loading = false;
				})
			},
			statusChange(val) {
				let status = val.status;
				if (status == 2) {
					status = 1;
				} else {
					status = 2
				}
				this.loading = true;
				this.httpPost({
					url: '/admin/fullreduction/change_status',
					data: {
						id: val.id,
						status: status
					}
				}).then((res) => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					}
					this.loading = false;
					this.getFullReduction();
				})
			},
			del(val){
				let id = val.id;
				this.msgBoxAjax(
				  '提示',
				  '确定删除吗？',
				  "/admin/fullreduction/del",
				  {id:id}).then((res) => {
				  // console.log(data);
							
				  if (res.code == 1) {
				    this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							
				      this.getFullReduction();
				    });
				  }else{
							
				    this.messageCommon('错误',res.msg,'error');
				  }		
				});
			},
			AddForm() {
				this.btnDisabled = false;
				this.form.items.push({
					'total_price_one': '',
					'total_price_two': '',
					'reduce_money': ''
				});
			},
			DeleteForm() {
				this.form.items.pop();
				if (this.form.items.length == 0) {
					this.btnDisabled = true;
				}
			},
			removeDomain(ii) {
				this.form.items.splice(ii, 1);
			},
			getProductType() {
				this.httpPost({
					url: '/admin/common/getProductType'
				}).then((res) => {
					this.options = res.data;
				})
			},
			edit(val) {
				// this.getVipGradeAll();
				this.getProductType();
				if (val) {
					this.resetObj(this.form)
					this.form.items = val.full_reduction;
					this.form.id = val.id;
					this.form.start_time = val.start_time;
					this.form.end_time = val.end_time;
					this.form.reduceprice_special = val.reduce_money;
					this.form.total_price_one_special = val.price_special.total_price_one;
					this.form.total_price_two_special = val.price_special.total_price_two;
					this.form.reduceprice_special = val.price_special.reduce_money;
					for (let i in val.product_type_id) {
						this.form.checkList.push(parseInt(val.product_type_id[i]))
					}
				} else {
					this.resetObj(this.form)
				}

				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateFullReduction();
					} else {
						console.log('error submit!')
						return false;
					}
				})
			},
			updateFullReduction() {
				let temp = this.cloneObj(this.form);

				let id = temp.id;

				if (!id) id = '';

				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/fullreduction/update?id=" + id,
					temp).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getFullReduction();
						});
					} else {

						this.messageCommon('错误', data.msg, 'error');
					}


				});
			}
		},
		created() {
			this.getFullReduction();
		}
	}
</script>

<style>
</style>
